<template>
  <div class="container">
    <div class="main">
      <div class="left">
        <div class="title">专业产品</div>
        <div class="text">
          智签科技提供丰富多样的产品维度，能够为各类金融纠纷提供司法化解方案，帮助您建立全方位、多元化的金融纠纷化解体系和解决能力。
        </div>
      </div>
      <div class="right">
        <div
          class="right_box"
          @click="routerPush('/product/existingEvidence')"
        >
          <div class="title">区块链存证平台</div>
          <div class="context">
            <div class="info">
              运用区块链技术，确保数据无法篡改、安全存储，从而保证交易数据的真实、可靠和完整。同时，我们提供存证、取证、用证的一站式数据保全能力，为您的数据安全提供全方位的保障。
            </div>
            <div class="tag">
              <div>
                <label>主要功能：</label>
                <span>区块链存证</span>
                <span>数据取证</span>
                <span>数据确权</span>
              </div>
              <!-- <div
                class="icon"
                @click="routerPush('/try')"
              >
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right_box" @click="routerPush('/product/signing')">
          <div class="title">
            Xcontract <br />
            区块链签约平台
          </div>
          <div class="context">
            <div class="info">
              基于区块链的电子合同签约功能+智能合约技术，自动实现合同的履约跟踪和追溯。旨在实现高效、安全、不可篡改的签约和解纷过程。
            </div>
            <div class="tag">
              <div>
                <label>主要功能：</label>
                <span>合同在线签署</span>
                <span>智能履约监控</span>
                <span>数据同步上链</span>
              </div>
              <!-- <div class="icon" @click="routerPush('/try')">
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right_box" @click="routerPush('/product/mediate')">
          <div class="title">金融多元化解平台</div>
          <div class="context">
            <div class="info">
              连接调解、公证、司法确认、仲裁、诉讼、执行等程序，以5G高清视频调解、线上呼叫中心、电话失联修复、在线电子送达等多元化解纷方式，最大程度地将金融纠纷化解在诉讼立案之前。
            </div>
            <div class="tag">
              <div>
                <label>主要功能：</label>
                <span>5G视频调解</span>
                <span>失联修复</span>
                <span>线上呼叫</span>
              </div>
              <!-- <div class="icon" @click="routerPush('/try')">
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right_box" @click="routerPush('/product/fq')">
          <div class="title">区块链赋强公证平台</div>
          <div class="context">
            <div class="info">
              为公证机构提供赋强公证业务的在线办理，涵盖赋强公证申请、审批、出具公证书、执行证书等步骤，全程同步上链，有效简化不良贷款处置流程，防范金融业务违约风险。
            </div>
            <div class="tag">
              <div>
                <label>主要功能：</label>
                <span>线上赋强申请</span>
                <span>在线出证</span>
                <span>区块链核验</span>
              </div>
              <!-- <div class="icon" @click="routerPush('/try')">
                申请试用 <i class="el-icon-arrow-right"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right_box" @click="openUrl">
          <div class="title">
            legalXChain <br />
            司法联盟区块链平台
          </div>
          <div class="context">
            <div class="info">
              基于legalFabric框架和要求开放的司法联盟链legalXchain，是针对政务、法律、监管等业务场景，链接司法机关、法律科技应用的司法界数据存证平台，目前已服务互联网版权、司法、金融、行政执法、品牌保护、智能签约等众多行业领域。
            </div>
            <div class="tag">
              <div>
                <label>主要功能：</label>
                <span>电子证据调取</span>
                <span>弹性灵活部署</span>
                <span>同步数字指纹</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="left_box" @click="openUrl">
          <div class="common_row">legalXchain</div>
          <div class="common_row">司法联盟区块链平台</div>
          <div class="info">
            司法联盟链legalXchain，目前已服务互联网版权、互联网司法、互联网金融、行政执法、品牌保护、智能签约等众多行业领域
          </div>
          <div class="common_title">适用纠纷</div>
          <div
            class="common_title_item"
            v-for="(item, index) in disputeData"
            :key="index"
          >
            {{ item.label }}
          </div>
        </div> -->
        <!-- <div class="right_box">
          <div
            class="right_box_item"
            @click="routerPush('/product/existingEvidence')"
          >
            <div class="title">区块链存证平台</div>
            <div class="info">
              基于区块链技术，保障数据拒绝篡改、安全存储，确保交易数据真实、可靠和完整。同时提供确权+取证+公证的一站式数据保全能力。
            </div>
            <div class="label">适用纠纷</div>
            <div class="label_item">斗殴</div>
            <div class="btn">申请试用 <i class="el-icon-right"></i></div>
          </div>
          <div class="right_box_item" @click="routerPush('/product/signing')">
            <div class="title">Xcontract区块链签约平台</div>
            <div class="info">
              企业可通过SAAS服务直接使用，还可以通过开放平台对接实现企业自有平台的签约服务。支持法院在线勘验或提取。
            </div>
            <div class="label">适用纠纷</div>
            <div class="label_item">斗殴</div>
            <div class="btn">申请试用 <i class="el-icon-right"></i></div>
          </div>
          <div class="right_box_item" @click="routerPush('/product/fq')">
            <div class="title">区块链赋强公证平台</div>
            <div class="info">
              运用区块链和互联网技术实现赋强公证业务的在线办理，强制执行的在线申请。可以形成贷前威慑、有效防范金融违约风险。
            </div>
            <div class="label">适用纠纷</div>
            <div class="label_item">斗殴</div>
            <div class="btn" @click.stop="fq_trial">
              申请试用 <i class="el-icon-right"></i>
            </div>
          </div>
          <div class="right_box_item" @click="routerPush('/product/mediate')">
            <div class="title">金融多元化解平台</div>
            <div class="info">
              连接调解、公证、司法确认、仲裁、诉讼、执行等各方，构建多元化、立体式的解纷体系。最大程度地将金融纠纷化解于诉讼立案之前
            </div>
            <div class="label">适用纠纷</div>
            <div class="label_item">斗殴</div>
            <div class="btn">申请试用 <i class="el-icon-right"></i></div>
          </div>

        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disputeData: [
        { label: "依照法律有效性设计" },
        { label: "123" },
        { label: "123" },
      ],
    };
  },

  created() {},

  methods: {
    fq_trial() {
      console.log("fq_trial");
    },
    routerPush(path) {
      this.$emit("close");

      this.$router.push(path);
    },
    openUrl() {
      window.open("https://www.legalxchain.com/cn/home", "_block");
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang='scss'>
.container {
  // background: url(~@/assets/image/header/product_menu1.png);
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  background-color: #f4f5f7;
  height: 540px;
  .main {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .left {
      width: 270px;
      position: relative;
      z-index: 99999;
      height: 100%;

      .title {
        margin: 40px 0 24px;
        color: #000000;
        position: relative;
        z-index: 99999;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #808080;
        position: relative;
        z-index: 99999;
        line-height: 20px;
        width: 207px;
        height: 96px;
      }
    }
    .left:before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 50vw;
      z-index: 0;
      height: 100%;
      background: #fff url(~@/assets/image/header/left.png) right bottom
        no-repeat;
      background-size: 650px auto;
    }
    .right {
      // background-color: #fff;
      width: 930px;
      height: 100%;
      padding: 34px 0 50px 40px;
      .right_box {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        display: flex;
        margin-bottom: 40px;
        align-items: center;
        cursor: pointer;
        .title {
          width: 140px;
          text-align: center;
          font-size: 14px;
          color: #37393b;
          margin-right: 10px;
        }
        .context {
          flex: 1;
          font-size: 12px;
          color: #656565;
          .info {
            margin-bottom: 13px;
          }
          .tag {
            display: flex;
            justify-content: space-between;
            label {
              color: #37393b;
              margin-right: 6px;
            }
            span {
              display: inline-block;
              height: 22px;
              border: 1px solid #7E7E7E;
              padding: 2px 18px;
              margin-right: 28px;
              color: #7E7E7E;
            }
            .icon {
              color: $main_color;
              cursor: pointer;
            }
          }
        }
      }
      .right_box:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
